var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigBattery(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 84.246,
    viewBox: "0 0 46 84.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#c8d1ec;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.333)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M42,78H4a4.005,4.005,0,0,1-4-4V4A4,4,0,0,1,4,0H42a4,4,0,0,1,4,4V74A4.005,4.005,0,0,1,42,78ZM19.414,43.159h0L17.745,55.332a1.112,1.112,0,0,0,.729,1.2,1.128,1.128,0,0,0,.393.07,1.142,1.142,0,0,0,.254-.029,1.129,1.129,0,0,0,.7-.484L33.311,35.416a1.106,1.106,0,0,0-.024-1.251,1.14,1.14,0,0,0-1.181-.447L27.353,34.8l1.314-12.116a1.113,1.113,0,0,0-.754-1.176,1.141,1.141,0,0,0-.372-.062,1.129,1.129,0,0,0-.958.523L13.5,42.547a1.106,1.106,0,0,0,.036,1.245,1.138,1.138,0,0,0,1.177.442l4.7-1.074Z",
    transform: "translate(-0.333 6.246)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.307,0H20.912a1.307,1.307,0,0,1,1.307,1.307V6.535a1.307,1.307,0,0,1-1.307,1.307H1.307A1.307,1.307,0,0,1,0,6.535V1.307A1.307,1.307,0,0,1,1.307,0Z",
    transform: "translate(12.035 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigBattery);
export default __webpack_public_path__ + "static/media/big_battery.37421b23f6f27a42402335fd734f5d3f.svg";
export { ForwardRef as ReactComponent };